// extracted by mini-css-extract-plugin
export default {"container":"Gv-z","title":"Hv-z","linkContainer":"Iv-z","viewItemLink":"Jv-z"};